export function exhaustiveGuard(message: string): never {
  throw new Error(`Reached forbidden guard function with unexpected value: ${message}`);
}
